import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

const BarChart = ({ domainsData }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    let myChart; // Declare chart variable

    if (chartRef.current) {
      const ctx = chartRef.current.getContext('2d');

      const palette = [
        'rgba(59, 164, 254, 0.35)',  // #3BA4FE
        'rgba(128, 81, 244, 0.35)',  // #8051F4
        'rgba(7, 34, 77, 0.20)',     // #07224D
        'rgba(146, 167, 190, 0.35)', // #92A7BE
        'rgba(13, 110, 253, 0.30)',  // deeper blue
        'rgba(0, 184, 255, 0.30)',   // cyan
      ];
      const borderPalette = [
        'rgba(59, 164, 254, 0.9)',
        'rgba(128, 81, 244, 0.9)',
        'rgba(7, 34, 77, 0.8)',
        'rgba(146, 167, 190, 0.9)',
        'rgba(13, 110, 253, 0.9)',
        'rgba(0, 184, 255, 0.9)',
      ];
      const backgroundColors = domainsData.map((_, i) => palette[i % palette.length]);
      const borderColors = domainsData.map((_, i) => borderPalette[i % borderPalette.length]);

      const data = {
        labels: domainsData.map(({ name }) => name),
        datasets: [{
          label: 'Domain Maturity',
          backgroundColor: backgroundColors,
          borderColor: borderColors,
          borderWidth: 1,
          data: domainsData.map(({ maturity }) => maturity),
        }],
      };

      const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            type: 'category',
            // labels: axisLabels, // Custom axis labels
            title: {
              display: true,
              text: 'Domains',
              font: {
                size: 22,
                weight: 'bold',
              },
              padding: {
                top: 40,
              },
            },
          },
          y: {
            beginAtZero: true,
            title: {
              display: true,
              text: 'Maturity',
              font: {
                size: 22,
                weight: 'bold',
              },
              padding: {
                bottom: 40,
              },
            },
            max: 4,
            ticks: {
              stepSize: 1,
            },
          },
        },
        plugins: {
          legend: {
            display: false,
          },
        },
      };

      // Destroy existing chart before creating a new one
      if (myChart) {
        myChart.destroy();
      }

      // Create a new bar chart instance
      myChart = new Chart(ctx, {
        type: 'bar',
        data: data,
        options: options,
      });
    }

    // Cleanup when the component is unmounted
    return () => {
      if (myChart) {
        myChart.destroy();
      }
    };
  }, [domainsData]);

  return (
    <div style={{ width: '100%', height: 580 }}>
      <canvas ref={chartRef}></canvas>
    </div>
  );
};

export default BarChart;
